import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../../services/api'

const TopCategoriesOne = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    // Background colors for category icons (will cycle through these)
    const bgColors = [
        'bg-info-50',
        'bg-success-50',
        'bg-purple-50',
        'bg-warning-50',
        'bg-danger-50',
        'bg-primary-50'
    ];

    // Icon paths (will cycle through these)
    const icons = [
        'assets/images/home-six/category-icon1.png',
        'assets/images/home-six/category-icon2.png',
        'assets/images/home-six/category-icon3.png',
        'assets/images/home-six/category-icon4.png',
        'assets/images/home-six/category-icon5.png',
        'assets/images/home-six/category-icon6.png'
    ];

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await api.categories.getAll();
                if (response.success) {
                    // Add visual elements to categories and limit to 6
                    const enhancedCategories = response.data.slice(0, 6).map((category, index) => {
                        return {
                            ...category,
                            backgroundColor: bgColors[index % bgColors.length],
                            iconPath: icons[index % icons.length],
                            // Estimate the exam count - in real app you might want to get this from API
                            examCount: Math.floor(Math.random() * 30) + 10 // Random number between 10-40
                        };
                    });
                    
                    setCategories(enhancedCategories);
                }
            } catch (error) {
                console.error('Error fetching categories:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
    }, []);

    return (
        <div className="col-xxl-4 col-md-6">
            <div className="card">
                <div className="card-header">
                    <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                        <h6 className="mb-2 fw-bold text-lg mb-0">Top Categories</h6>
                        <Link
                            to="/add-categories"
                            className="text-primary-600 hover-text-primary d-flex align-items-center gap-1"
                        >
                            View All
                            <Icon
                                icon="solar:alt-arrow-right-linear"
                                className="icon"
                            />
                        </Link>
                    </div>
                </div>
                <div className="card-body">
                    {loading ? (
                        <div className="text-center py-4">Loading categories...</div>
                    ) : categories.length === 0 ? (
                        <div className="text-center py-4">No categories found</div>
                    ) : (
                        categories.map((category, index) => (
                            <div 
                                key={category._id || index} 
                                className={`d-flex align-items-center justify-content-between gap-3 ${index < categories.length - 1 ? 'mb-24' : 'mb-0'}`}
                            >
                                <div className="d-flex align-items-center gap-12">
                                    <div className={`w-40-px h-40-px radius-8 flex-shrink-0 ${category.backgroundColor} d-flex justify-content-center align-items-center`}>
                                        <img
                                            src={category.iconPath}
                                            alt={category.name}
                                            className=""
                                        />
                                    </div>
                                    <div className="flex-grow-1">
                                        <h6 className="text-md mb-0 fw-normal">{category.name}</h6>
                                        <span className="text-sm text-secondary-light fw-normal">
                                            {category.examCount}+ Exams
                                        </span>
                                    </div>
                                </div>
                                <Link
                                    to={`/admin/categories/${category._id}`}
                                    className="w-24-px h-24-px bg-primary-50 text-primary-600 d-flex justify-content-center align-items-center text-lg bg-hover-primary-100 radius-4"
                                >
                                    <i className="ri-arrow-right-s-line" />
                                </Link>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default TopCategoriesOne;